/* eslint-disable no-console */
import { useEffect } from 'react';

/**
 * useHubSpotForm is a custom hook that creates a HubSpot form
 * with the specified portalId, formId, and target (DOM element ID).
 * The hook takes care of loading the HubSpot script, initializing
 * the form, and handling errors.
 *
 * @param {string} portalId - The HubSpot portal ID.
 * @param {string} formId - The HubSpot form ID.
 * @param {string} target - The DOM element ID where the form will be rendered.
 */
export default function useHubSpotForm(hubspotForm) {
  const { portalId, formId, target } = hubspotForm;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      script.async = true;
      document.body.appendChild(script);

      const handleLoad = () => {
        if (window.hbspt) {
          try {
            window.hbspt.forms.create({
              portalId,
              formId,
              target,
            });
          } catch (error) {
            console.error('Failed to create the HubSpot form:', error);
          }
        } else {
          console.error(
            'HubSpot script loaded, but hbspt object not available.'
          );
        }
      };

      const handleError = () => {
        console.error('Failed to load the HubSpot script.');
      };

      script.addEventListener('load', handleLoad);
      script.addEventListener('error', handleError);

      return () => {
        script.removeEventListener('load', handleLoad);
        script.removeEventListener('error', handleError);
        document.body.removeChild(script);
      };
    }
  }, [portalId, formId, target]);
}
